import { Component } from '@theme/component';

/**
 * Help center horizontal nav bar.
 *
 * On load, horizontally scrolls the (overflow-x) link list so the active
 * item ([aria-current="page"]) is centered — matters on mobile where the
 * bar scrolls.
 *
 * @extends {Component<{}>}
 */
class HelpMenuBar extends Component {
	connectedCallback() {
		super.connectedCallback();

		const active = this.querySelector('[aria-current="page"]');
		const list = this.querySelector('.help-menu-bar__links');
		if (!active || !list || list.scrollWidth <= list.clientWidth) return;

		const target = active.offsetLeft - list.clientWidth / 2 + active.offsetWidth / 2;
		list.scrollLeft = Math.max(0, target);
	}
}

if (!customElements.get('help-menu-bar')) {
	customElements.define('help-menu-bar', HelpMenuBar);
}
